// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__1FEM2","row":"Node_row__SKTnl","label":"Node_label__xxI9d","footer":"Node_footer__3n1ef"};